import React from 'react';
import styles from "./PhuHuynhNameAndAvavtar.module.css";
import UserAvatar from '../../../components/user-avatar';

interface PhuHuynhProps {
  ho_ten?: string;
  dien_thoai?: string;
  ma_tn?: string;
  avatar?: string;
}

interface PhuHuynhNameAndAvatarProps {
  phuHuynh: PhuHuynhProps;
}

const PhuHuynhNameAndAvavtar: React.FC<PhuHuynhNameAndAvatarProps> = ({ phuHuynh }) => {
  return (
    <div className={styles.container}>
      <UserAvatar fullName={phuHuynh.ho_ten} size="medium" />
      <div className={styles.info}>
        <div className={styles.ho_ten}>{phuHuynh.ho_ten}</div>
        <div className={styles.ma_hs}>{phuHuynh.dien_thoai || phuHuynh.ma_tn || ""}</div>
      </div>
    </div>
  );
};

export default PhuHuynhNameAndAvavtar;
